import FingerprintJS from "@fingerprintjs/fingerprintjs";

const FALLBACK_KEY = "guide_pages_device_id";

function readFallbackId() {
  try {
    const stored = localStorage.getItem(FALLBACK_KEY);
    if (stored) return stored;
    const id = `web-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(FALLBACK_KEY, id);
    return id;
  } catch {
    return `web-${Date.now()}`;
  }
}

export const generateDeviceId = async () => {
  if (process.env.NODE_ENV === "development") {
    return readFallbackId();
  }
  try {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId;
  } catch (err) {
    console.warn("[generateDeviceId] 指纹失败，使用本地 fallback", err);
    return readFallbackId();
  }
};

export default generateDeviceId;
